import Head from "next/head";
import TopCategoryAdd from "../ads/category-top-add"
import ProductSmallTile from "../product-tile/product-small-tile";
import styles from './category.module.css';
import { useEffect, useState } from "react";
import { server } from "../../config";
import Link from "next/link";
export default function CategoryPageContent ({result, category, content, categoryDescription, customHeader}: {result:any, category: string, content: string, categoryDescription: string, customHeader?: string}) {
  const [totalRows, setTotalRows] = useState(0);
  
  useEffect(() => {
    getTotal().then();
  }, []);

	const getTotal = async () => {
		const response = await fetch(`${server}/api/category/getTotal?c=${category}`);
		const res = await response.json();
		setTotalRows(res);
	}    

	return (
	<div className={styles.categoryContainer} style={{}}>
			<Head>
        <title>{`${customHeader || category.toString()} - Sexleketøy`}</title>
				<meta name="description" content={categoryDescription.toString()?.substring(0,150)} />
				<meta name="og:title" content={`${customHeader || category.toString()} - Sexleketøy`}></meta>
				<meta name="og:description" content={categoryDescription.toString()?.substring(0,150)}></meta>
        <link rel="canonical" href={`https://billigesexleker.no/sexleketoy/${category}`} />      
			</Head>
      <main className={styles.categoryWrapper}>
        <div className="showInMobile">
          <a href="https://www.nytelse.no/tt/?tt=12509_2239543_263403_&amp;r=" target="_blank" rel="sponsored nofollow"><img src="https://ti.tradetracker.net/?c=12509&amp;m=2239543&amp;a=263403&amp;r=&amp;t=html" width="300" height="250" alt="Nytelse kampanje" /></a>        
        </div>
        <div className="hideInMobile hideOnPad">
          
        </div>        
        <h1>{customHeader || category}</h1>
        <article className={styles.categoryIngress} dangerouslySetInnerHTML={{__html:content}}></article>    
        <br/>
        <article className={`${styles.categoryIngress} ${styles.mobilePadding}`} style={{fontWeight: 500}}>
          {Math.round(totalRows / 100) * 100 > 0 ? `Billigesexleker.no har over ${Math.round(totalRows / 100) * 100} produkter i denne kategorien.` : ''}<br/>
          Bruk <Link href={`/sok?q=${category}`} passHref>søket</Link> for å finne det du leter etter. Under vises et utvalg populære produkter.
        </article>        
      </main>
        <div>
            <a className="showInMobile" style={{ marginTop: '32px' }}href="https://www.nytelse.no/tt/?tt=12509_2217201_263403_&amp;r=" target="_blank" rel="sponsored nofollow">
              <img src="https://ti.tradetracker.net/?c=12509&amp;m=2217201&amp;a=263403&amp;r=&amp;t=html" style={{width: '380px'}} alt="nytelseKampanje" />
            </a>
        </div>  
      <h4 className={styles.mobilePadding}>Utvalgte produkter</h4>
      <main style={{textAlign: 'center'}}>{result.map((p: any, index: number) => {
        return <ProductSmallTile detailsPath={'/sexleketoy/produkter'} size='normal' key={index} product={p}></ProductSmallTile>
      })}
      <div style={{marginTop: '32px', textAlign: 'center'}}>
        <Link href={`/sok?q=${category}`} passHref style={{fontSize: '18px'}}>Se flere produkter</Link>
      </div>
      </main>
      
      <br/>
      <div className="hideInMobile hideOnPad" style={{marginTop: '32px'}}>
        <a href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=110645" target="_blank" rel="nofollow noopener">
        <img src="https://www.partner-ads.com/no/visbanner.php?partnerid=30465&bannerid=110645" alt="Merlykke.no" /></a>
      </div>
      <div className="showInMobile" style={{ marginTop: '32px' }}>
        <a href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=110643" target="_blank" rel="nofollow noopener">
        <img src="https://www.partner-ads.com/no/visbanner.php?partnerid=30465&bannerid=110643" alt="Merlykke.no" /></a>
      </div>
    </div>
	)
}